"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require("../../module");

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresShareButtonController = function () {
    function WinresShareButtonController($rootScope, $scope, $window) {
        _classCallCheck(this, WinresShareButtonController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$window = $window;
    }

    _createClass(WinresShareButtonController, [{
        key: "$onInit",
        value: function $onInit() {

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination

            this.data = this.winresReservationContext.getContext();
            this.ogUrl = window.location.href.replace("#", "%23");

            if (this.pageUrl == undefined) {
                this.path = this.$window.location.href;
                this.splitPath = this.path.split("/");
                this.finalPath = "";
                var i = 0;
                while (this.splitPath[i].indexOf("#!") === -1) {
                    this.finalPath = this.finalPath + this.splitPath[i] + "/";
                    i = i + 1;
                }

                this.linkUrl = this.finalPath;
            } else {
                this.linkUrl = this.pageUrl;
            }
        }
    }, {
        key: "shortDesc",
        value: function shortDesc(desc) {
            this.short = desc.split(".");
            this.short2 = this.short[0].replace(/ /g, "+");
            return this.short2;
        }
    }, {
        key: "shortTitle",
        value: function shortTitle(desc) {
            this.short = desc.replace(/ /g, "+");
            return this.short;
        }
    }, {
        key: "openFacebook",
        value: function openFacebook() {
            this.$window.open('http://www.facebook.com/sharer.php?u=' + this.linkUrl + '?photourl=' + this.data.Destination.Images[0] + '&ogtitle=' + this.shortTitle(this.data.Destination.DestinationName) + '&ogdesc=' + this.shortDesc(this.data.Destination.DescriptionOfDestination) + '&ogurl=' + this.ogUrl);
        }
    }, {
        key: "openTwitter",
        value: function openTwitter() {
            this.$window.open('http://twitter.com/home?status=' + this.ogUrl);
        }
    }, {
        key: "openLinkedin",
        value: function openLinkedin() {
            this.$window.open('http://linkedin.com/shareArticle?mini=true&amp;url=' + this.ogUrl);
        }
    }, {
        key: "openPinterest",
        value: function openPinterest() {
            this.$window.open('http://pinterest.com/pin/create/button/?url=' + this.ogUrl);
        }
    }, {
        key: "openTumblr",
        value: function openTumblr() {
            this.$window.open('http://www.tumblr.com/share/link?url=' + this.ogUrl);
        }
    }, {
        key: "openMail",
        value: function openMail() {
            this.$window.open('mailto:?subject=Golfresepti&body=' + this.ogUrl);
        }
    }]);

    return WinresShareButtonController;
}();

WinresShareButtonController.$inject = ['$rootScope', '$scope', '$window'];

_module3.default.component('winresShareButton', {
    template: require('./winresShareButton.html'),
    controller: WinresShareButtonController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        pageUrl: '@', // url of the kohdesivu/matkasivu eg. "http://comgate.fi/supergolf/matkasivu/". If not defined, gets it automatically
        text: '@', // the string displayed on the top, by default: 'share on: '
        facebook: '@', // true / false (default)
        twitter: '@', // true / false (default)
        pinterest: '@', // true / false (default)
        linkedin: '@', // true / false (default)
        tumblr: '@', // true / false (default)
        mailto: '@', // true / false (default)
        mailtotext: '@' // the string displayed next to mailto share button
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresShareButton/winresShareButton.js
// module id = 382
// module chunks = 2